
import React, {useState, useEffect} from "react";
import { withPrefix } from "gatsby";
// import { useTranslation} from 'gatsby-plugin-react-i18next';
import { Navigator as Navigation } from '../components/navigator/navigator';
import { Menu } from "../components/menu/menu";
import '../styles/reset.scss';
import '../styles/base.scss';
import '../styles/_global/font.scss';
import { Helmet } from "react-helmet";
import GlobalContextProvider from "../layouts/globalContext"; // to access state in layout from prehome
import audioTrack from "../audio/reverie_Debussy.mp3";
import favicon from "../images/icon.png";

export default function Layout({ children, lines, page, navigation, type, language, data}) {

  if(typeof document !== 'undefined'){
    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab' || e.key === 9;


        if(isTabPressed) {
          document.body.classList.add('is-tabbing')
        } else {
          document.body.classList.remove('is-tabbing')
        }
    });  
  }
  

  // const context = React.useContext(I18nextContext);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  // js for onetrust (cookie banner)
  let oneTrustId = {
      'ii': '67be8d9d-9cae-4eaf-b31b-da38f82ae280',
      'it': '54385df3-ec0f-4666-ae61-38fe9441f996',
      'us': 'ed486ac5-ea27-4f2d-bdf1-a4792732ca42',
      'jp': '7a756db4-b121-47bf-bb1b-8af32d7841cd',
      'kr': 'a80408f2-e596-4fe3-bdd8-333eb5acb122',
      'ae': '054b4344-5e71-43dd-b107-37a722fa3074',
      'cz': 'be1953c7-adf9-4b85-976f-b29fc1c475ed',
      'qa': '48ead88a-4c54-4841-baa1-18225bff8c8f',
      'de': '1462ff1c-b9de-4473-839e-2a27dcb183ec',
      'hu': '2ef7b32b-809d-490f-8031-8d885d289e5e',
      'at': 'f609bbdf-cf57-434c-b66e-20b86a4cdaac',
      'dk': '8f475de0-bcbd-4b33-aa5c-8286995d2e7c',
      'fr': 'f664db2a-db0e-4793-a32a-d6d159c905f9',
      'lv': '579413b3-6061-4f89-a159-121a9e4e44db',
      'uk': 'a9bb1132-efa6-47cb-bf88-f7c5e7746f68',
      'hr': 'f6a35b55-ad13-4015-8b4e-e2bf8c243ceb',
      'lu': '45d1dc62-2449-457d-b44e-f725444737cf',
      'ro': 'bdbce731-3576-4940-b050-abd78fc55f24',
      'lt': '6c29bcf8-9f8f-490b-817f-31307992a8f1',
      'ee': '4c3bfe41-7815-4d32-9c2b-a2fd753513e2',
      'mt': '4ff37e27-d949-4b23-8a3e-1d279300c36d',
      'cy': 'd13b5e1a-1bbb-468e-8899-f4a6dffe11fb',
      'pt': '1d83be82-110e-4af3-8e4d-0f08c36d6713',
      'se': '7eb45e82-a97f-4a75-ac04-3251581625a1',
      'fi': '5bd835dd-5c7d-43c6-b6d1-ce784072ae72',
      'bg': '98d9fc05-1798-42dd-a548-58198709fa01',
      'gr': 'ffb36883-ec4b-49c7-b16b-5f92fb244c7e',
      'si': 'ed1226ba-8444-47df-982d-535fba9500e9',
      'be': 'a58de472-07fe-4812-8229-477835c1fa77',
      'es': '9333a45f-5f1b-4c0d-9c48-36f3c896331f',
      'pl': '76b4225d-f7a6-4a17-bb0b-8002dc1e4053',
      'sk': '723feb6e-29bd-4d68-bf9d-3bcd810a821c',
      'ie': '34f8dbd6-c490-4867-a17d-738fe734e117',
      'nl': '5efb0a18-31fa-4a35-9aa6-5a908d9e7655',
      'mc': '9a7814b8-4885-4bc1-bc48-97062e6790fa',
      'sa': '9b74b193-2bcd-4778-9e53-8baf19ed76e0',
      'ch': '0fd6d8c2-1fef-4530-b8b9-75a543c144b0',
      'ii-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'it-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'us-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'jp-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'kr-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'ae-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'cz-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'qa-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'de-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'hu-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'at-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'dk-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'fr-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'lv-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'uk-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'hr-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'lu-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'ro-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'lt-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'ee-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'mt-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'cy-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'pt-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'se-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'fi-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'bg-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'gr-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'si-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'be-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'es-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'pl-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'sk-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'ie-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'nl-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'mc-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'sa-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test',
      'ch-qa': '07216493-2e81-40f0-b1c8-d26a977468b3-test'
  };

  function injectScript(src, dataDomainScript) {
      return new Promise((resolve, reject) => {
          const scriptIncl = document.createElement('script');
          scriptIncl.src = src;
          scriptIncl.setAttribute("data-domain-script", dataDomainScript);
          scriptIncl.addEventListener('load', resolve);
          scriptIncl.addEventListener('error', e => reject(e.error));
          document.head.appendChild(scriptIncl);

          const scriptFunct = document.createElement('script');
          scriptFunct.type = 'text/javascript';
          scriptFunct.appendChild(document.createTextNode('function OptanonWrapper() { }'));
          document.head.appendChild(scriptFunct);
      });
  }
  useEffect(() => {
    if(language !== 'zh_hans'){
      if (typeof window !== "undefined") {
        if (window.location.hostname.split('.')[0] !== 'undefined') {
          let domain = window.location.hostname.split('.')[0];
          if (oneTrustId[domain] !== 'undefined') {
              injectScript('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', oneTrustId[domain])
                  .then(() => {
                      //console.log('Script loaded with', oneTrustId[domain]);
                  }).catch(error => {
                      console.error(error); 
                  });
          }
        }
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-K857KVF');
    
      }  
    }
  },[])

  let href = typeof window !== 'undefined' ? window.location.href : '';
  useEffect(() => {
    let url = window.location.href;
    if(window.dataLayer){
        window.dataLayer.push({
        event: 'virtual_pageview',
        varpath: url
      });
    }
  }, [href]);

  
  // end js for onetrust (cookie banner)

  function handleOpenMenu(){
    setOpen(true);
    setClose(false);
  }

  function handleCloseMenu(){
    setOpen(false);
    setClose(true);

  }

  return (
    <GlobalContextProvider>
      <div className={`${lines ? 'layout--lines' : '' } layout ${type === 'simple' ? 'layout--simple' : '' } ${page}Page`}>
      <audio controls  className="header__soundControls" id="soundId" tabIndex="-1">
        <source src={audioTrack} type="audio/ogg"/>
        <source src={audioTrack} type="audio/mpeg"/>
        Your browser does not support the audio tag.
      </audio>
      {lines && <div className="layout__line" />}
        <Helmet
          htmlAttributes={{
            lang: language,
          }}>
          <meta
            name="viewport"
            content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
          />
          <meta
            name="title"
            content={data['metaTitle']}
          />
          <meta
            name="description"
            content={data['metaDescription']}
          />
          <link rel="icon"  type="image/png" href={favicon}></link>
          <link href={withPrefix("onetrust.css")} rel="stylesheet" type="text/css" />
          <title>{data['metaTitle']}</title>

        </Helmet>
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K857KVF" height="0" width="0" style={{display:'none'}}></iframe></noscript>

        <div className="content">{children}</div>

        {navigation &&
          <div className="layout__navigation">
            <Navigation currentPage = {page} openMenu = {handleOpenMenu} close={close} language={language} data={data}></Navigation>
            <Menu open={open} closeMenu={handleCloseMenu} language={language} data={data}></Menu>
          </div>
        }
      </div>
    </GlobalContextProvider>
  )

}

